<mat-form-field appearance="outline">
  <mat-label>{{ placeholder }}</mat-label>
  <input type="text"
         [placeholder]="placeholder"
         aria-label="Value"
         matInput
         [formControl]="control"
         [matAutocomplete]="auto"
         [readonly]="disabled"
         >
  <mat-icon matSuffix *ngIf="control.value && !disabled" (click)="limpiar()" class="clear-icon" role="button" tabindex="0">close</mat-icon>
  <mat-autocomplete #auto="matAutocomplete" panelWidth="auto" [displayWith]="displayFn.bind(this)" (optionSelected)="onOptionSelected($event)">
    <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
      {{ option[displayField] }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>